import React, {Component} from 'react';
import classNames from 'classnames';
import {centsToPrice} from '../utils/filters';
import {opacityFadeDuration} from '../config/animation';
import {connectToStore} from './Provider';
import IconArrowPagination from './IconArrowPagination';
import {Transition} from 'react-transition-group';
import { Link } from 'gatsby';

const BG_DEFAULT_STYLE = {
	transition: `opacity ${opacityFadeDuration}ms ease-in-out`,
};

const BG_TRANSITION_STYLES = {
	entering: {
		opacity: 0
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		opacity: 0,
	},
	exited: {
		opacity: 0,
	}
};

const BG_MOBILE_DEFAULT_STYLE = {
	transition: `opacity ${opacityFadeDuration}ms ease-in-out`,
};

const BG_MOBILE_TRANSITION_STYLES = {
	entering: {
		opacity: 0
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		opacity: 0,
	},
	exited: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		opacity: 0,
	}
};

const CONTENT_DEFAULT_STYLE = {
	transition: `opacity ${opacityFadeDuration}ms ease-in-out`,
};

const CONTENT_TRANSITION_STYLES = {
	entering: {
		opacity: 0
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		opacity: 0,
	},
	exited: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		opacity: 0,
	}
};


class NewReleaseCarousel extends Component {
	constructor() {
		super();

		this.state = {
			activeSlideIndex: 0,
			isTransitioning: false,
		};
	}

	onClickPrevious = () => {
		if (this.state.isTransitioning) return;

		if (this.state.activeSlideIndex <= 0) {
			this.setState({
				activeSlideIndex: this.props.slides.length - 1,
				isTransitioning: true,
			});
		} else {
			this.setState({
				activeSlideIndex: this.state.activeSlideIndex - 1,
				isTransitioning: true,
			});
		}

		setTimeout(() => {
			this.setState({
				isTransitioning: false,
			});
		}, opacityFadeDuration);
	}

	onClickNext = () => {
		if (this.state.isTransitioning) return;

		if (this.state.activeSlideIndex >= this.props.slides.length - 1) {
			this.setState({
				activeSlideIndex: 0,
				isTransitioning: true,
			});
		} else {
			this.setState({
				activeSlideIndex: this.state.activeSlideIndex + 1,
				isTransitioning: true,
			});
		}

		setTimeout(() => {
			this.setState({
				isTransitioning: false,
			});
		}, opacityFadeDuration);
	}

	render() {
		const {
			title,
			slides,
			openQuickAddProduct,
		} = this.props;

		const {
			activeSlideIndex,
		} = this.state;

		const activeSlide = slides[activeSlideIndex];

		const releaseBgSlides = slides.map((slide, index) => (
			<Transition
				key={`${index}_${slide._key}_bg`}
				in={index === activeSlideIndex}
				mountOnEnter
				unmountOnExit
				timeout={{
					enter: 0,
					exit: opacityFadeDuration
				}}>{(state) => (
				<React.Fragment>
					<div
						style={{
							...BG_DEFAULT_STYLE,
							...BG_TRANSITION_STYLES[state],
						}}
						className="image--cover show--md">
						<picture>
							<source
								srcSet={`${slide.backgroundImage}?w=2000&auto=format`}
								media="(min-width: 1400px)"
							/>
							<source
								srcSet={`${slide.backgroundImage}?w=1600&auto=format`}
								media="(min-width: 800px)"
							/>
							<source
								srcSet={`${slide.mobileBackgroundImage}?w=1600&auto=format`}
								media="(min-width: 600px)"
							/>
							<img
								alt={slide.product ? slide.product.title : null}
								src={`${slide.mobileBackgroundImage}?w=800&auto=format`}
							/>
						</picture>
					</div>
					<div
						style={{
							...BG_MOBILE_DEFAULT_STYLE,
							...BG_MOBILE_TRANSITION_STYLES[state],
						}}
						className="image size--1x1 hide--md">
						<picture>
							<source
								srcSet={`${slide.backgroundImage}?w=2000&auto=format`}
								media="(min-width: 1400px)"
							/>
							<source
								srcSet={`${slide.backgroundImage}?w=1600&auto=format`}
								media="(min-width: 800px)"
							/>
							<source
								srcSet={`${slide.mobileBackgroundImage}?w=1600&auto=format`}
								media="(min-width: 600px)"
							/>
							<img
								alt={slide.product ? slide.product.title : null}
								src={`${slide.mobileBackgroundImage}?w=800&auto=format`}
							/>
						</picture>
					</div>
				</React.Fragment>
			)}</Transition>
		));

		const releaseBgColorSlides = slides.map((slide, index) => (
			<Transition
				key={`${index}_${slide._key}_bg`}
				in={index === activeSlideIndex}
				mountOnEnter
				unmountOnExit
				timeout={{
					enter: 0,
					exit: opacityFadeDuration
				}}>{(state) => (
				<div
					style={{
						...BG_DEFAULT_STYLE,
						...BG_TRANSITION_STYLES[state],
					}}
					className={classNames('new-release__bg-transition', {
						'invert': slide.invertBackground,
					})}
				/>
			)}</Transition>
		));
		
		const releaseContentSlides = slides.map((slide, index) => (
			<Transition
				key={`${index}_${slide._key}_content`}
				in={index === activeSlideIndex}
				mountOnEnter
				unmountOnExit
				timeout={opacityFadeDuration}>{state => {
					return (
						<div
							style={{
								...CONTENT_DEFAULT_STYLE,
								...CONTENT_TRANSITION_STYLES[state],
							}}>
							<div
								className={classNames('fw--500 sans--small new-release__text-transition pt3 pt8--md pb8--md', {
									'color--white': slide.invertBackground,
								})}>
								{slide.product && (
									<div>
										<h3 className="domaine--large mb2">
											{slide.product.brand}
										</h3>
										<h2 className="color--gray-text sans--medium mb2">
											{slide.product.title}
										</h2>
										<p className="domaine--medium mb3">
											{centsToPrice(slide.product.cents)}
										</p>
									</div>
								)}
								{slide.product && (
									<div className="row">
										<div className="col c6--md c5--lg">
											<div className="row gutter--mobile">
												<div className="col c6--md c5--lg mb2 mb0--md">
													<button
														title="Quick Shop"
														name="add"
														onClick={() => openQuickAddProduct(slide.product)}
														className={classNames('full-width', {
															'button--primary-black': !slide.invertBackground,
															'button--primary-white': slide.invertBackground,
														})}>
														Quick Shop
													</button>
												</div>
												<div className="col c6--md c5--lg">
													<Link
														to={`/products/${slide.product.slug}`}
														className={classNames('full-width', {
															'button--secondary': !slide.invertBackground,
															'button--secondary-white': slide.invertBackground,
														})}>
														Details
													</Link>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					);
				}}</Transition>
		));

		const carouselPagination = (
			<ul className="list list--horizontal list--forward gutter--small tr tl--md align--middle">
				<li className="list__item">
					<button
						title="Previous"
						onClick={this.onClickPrevious}
						className="db"
						name="previous">
						<IconArrowPagination
							alt="arrow"
							className="flip db new-release__arrow-transition"
							color={activeSlide.invertBackground ? '#FFF' : '#000'}
						/>
					</button>
				</li>
				<li className="list__item">
					<p
						className={classNames('fw--500 sans--small new-release__text-transition', {
							'color--white': activeSlide.invertBackground,
						})}>
						{activeSlideIndex + 1} of {slides.length}
					</p>
				</li>
				<li className="list__item">
					<button
						title="Next"
						onClick={this.onClickNext}
						className="db"
						name="next">
						<IconArrowPagination
							alt="arrow"
							className="db new-release__arrow-transition"
							color={activeSlide.invertBackground ? '#FFF' : '#000'}
						/>
					</button>
				</li>
			</ul>
		);

		const header = (
			<div className="row">
				<div className="col c6--md c5--lg">
					<div className="media media--horizontal media--reverse gutter--small align--middle mb3 mb4--md">
						<div className="media__fluid">
							<h2
								className={classNames('uppercase fw--600 new-release__text-transition', {
									'color--white': activeSlide.invertBackground
								})}>
								{title}
							</h2>
						</div>
						<div className="media__fixed hide--md">
							{carouselPagination}
						</div>
					</div>
					<hr
						className={classNames('new-release__hr-transition', {
							invert: activeSlide.invertBackground
						})}
					/>
				</div>
			</div>
		);

		return (
			<div className="of--hidden">
				<div className="pr">
					{releaseBgColorSlides}
					{releaseBgSlides}
					<div className="grid-container pt3 pb6 pt12--lg pb12--lg push-up">
						{header}
						<div className="pr">
							{releaseContentSlides}
						</div>
						<div className="row show--md">
							<div className="col c6--md c5--lg">
								<hr
									className={classNames('new-release__hr-transition mb4', {
										invert: activeSlide.invertBackground
									})}
								/>
								{carouselPagination}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
	openQuickAddProduct,
}) => ({
	openVideoModal,
	openQuickAddProduct,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(NewReleaseCarousel);